import { render, staticRenderFns } from "./m_chineseplus_classlive.vue?vue&type=template&id=15fa0ff2&scoped=true"
import script from "./m_chineseplus_classlive.vue?vue&type=script&lang=js"
export * from "./m_chineseplus_classlive.vue?vue&type=script&lang=js"
import style0 from "./m_chineseplus_classlive.vue?vue&type=style&index=0&id=15fa0ff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa0ff2",
  null
  
)

export default component.exports